import type { HiddenMetrics } from '@/modules/workspace/composables/use-hidden-metrics'
import { Column } from '@/modules/shared/utils/v-table'

const entity_columns: Column[] = [
  {
    key: 'name',
    name: 'Name',
    type: 'string',
    is_visible: true,
    fixed: true,
  },
  {
    key: 'group.name',
    name: 'Group',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'group.subdomain',
    name: 'Group Subdomain',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'legal_name',
    name: 'Legal Name',
    type: 'string',
    is_visible: false,
  },
  // {
  //   name: 'Entity Status',
  //   key: 'entity_status',
  //   type: 'string',
  //   is_visible: false,
  // },
  {
    key: 'type',
    name: 'Type',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'tax_id',
    name: 'Tax ID',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'date',
    name: 'Date Established',
    type: 'date',
    is_visible: false,
  },
  {
    key: 'document_status',
    name: 'Documents Status',
    type: 'string',
    is_visible: true,
  },
  {
    key: 'amount_invested',
    name: 'Amount Invested',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'capital_committed',
    name: 'Capital Committed',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'capital_called',
    name: 'Capital Called',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'capital_pending',
    name: 'Capital Pending',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'management_fees',
    name: 'Management Fees',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'other_called_fees',
    name: 'Other Called Fees',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'other_disbursement_fees',
    name: 'Other Disburesment Fees',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'total_called',
    name: 'Total Called (with fees)',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'commitment_remaining',
    name: 'Commitment Remaining',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'net_distributed',
    name: 'Total Disbursed',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'carried_interest_distributed',
    name: 'Carried Interest',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'selected_subscriptions',
    csv_key: 'selected_services',
    name: 'Subscriptions',
    type: 'string',
    is_visible: true,
  },
  // {
  //   key: 'blue_sky_status',
  //   name: 'Blue Sky Status',
  //   type: 'string',
  //
  //   is_visible: true,
  // },
  {
    key: 'investors',
    name: 'Investors',
    type: 'number',
    aggregate: 'average',
    is_visible: true,
  },
  // {
  //   key: 'book_value.beginning_balance',
  //   name: 'Beginning Balance',
  //   type: 'currency',
  //   aggregate: 'sum',
  //
  //   is_visible: true,
  // },
  // {
  //   key: 'book_value.ending_balance',
  //   name: 'Current Balance',
  //   type: 'currency',
  //   aggregate: 'sum',
  //
  //   is_visible: true,
  // },
  {
    key: 'address.street1',
    name: 'Street 1',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'address.street2',
    name: 'Street 2',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'address.city',
    name: 'City',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'address.state',
    name: 'State',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'address.zip_code',
    name: 'Zip Code',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'address.country',
    name: 'Country',
    type: 'string',
    is_visible: false,
  },
]

const call_columns = (isAdmin: boolean): Column[] => [
  {
    key: 'shareholder.name',
    name: 'Investor',
    type: 'string',
    fixed: true,
    is_visible: true,
  },
  {
    key: 'shareholder.cid',
    name: 'CID',
    type: 'string',
    is_visible: false,
    is_accessible: isAdmin,
  },
  {
    key: 'shareholder.tax_id',
    name: `SSN / EIN`,
    type: 'string',
    is_visible: false,
  },
  {
    key: 'investor_set.name',
    name: 'Entity',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'due_date',
    name: 'Due Date',
    sorted: true,
    sort_order: 'desc',
    type: 'date',
    is_visible: true,
  },
  {
    key: 'call_date',
    name: 'Call date',
    type: 'date',
    is_visible: false,
  },
  {
    key: 'type',
    name: 'Type',
    type: 'string',
    is_visible: true,
  },
  {
    key: 'capital',
    name: 'Capital',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'invoice.display_status',
    name: 'Invoice Status',
    type: 'string',
    is_visible: true,
  },
  {
    key: 'actions',
    name: '',
    type: 'actions',
    is_visible: true,
  },
]

const distribution_method_columns: Column[] = [
  {
    key: 'shareholder.disbursement_method_confirmed_at',
    name: 'Payment Method Confirmed At',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.disbursement_wire_bank_name',
    name: 'Bank Name',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.disbursement_wire_bank_address',
    name: 'Bank Address',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.disbursement_wire_bank_routing_number',
    name: 'Bank Routing Number',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.disbursement_wire_bank_account_number',
    name: 'Bank Account Number',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.disbursement_wire_bank_swift_code',
    name: 'Bank Swift Code',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.disbursement_wire_account_name',
    name: 'Account Name',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.disbursement_wire_for_further_credit_to',
    name: 'For Further Credit To',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.disbursement_wire_bank_notes',
    name: 'Additional Banking Details',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.disbursement_check_receiver_name',
    name: 'Check Receiver Name',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.disbursement_other_details',
    name: 'Other Payment Method Details',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
]

const addressColumns = ({ keyPrefix = '' }: { keyPrefix?: string } = {}): Column[] => {
  const prefix = keyPrefix ? `${keyPrefix}.` : ''

  const addressAttributes = [
    { key: 'line1', name: 'Line 1' },
    { key: 'line2', name: 'Line 2' },
    { key: 'city', name: 'City' },
    { key: 'state', name: 'State' },
    { key: 'postal_code', name: 'Postal Code' },
    { key: 'country', name: 'Country' },
  ]

  return addressAttributes.map(({ key, name }) => ({
    key: `${prefix}address.${key}`,
    name,
    type: 'string',
    is_visible: false,
  }))
}

const shareholder_columns: Column[] = [
  {
    key: 'shareholder.investing_name',
    name: 'Legal Name',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'shareholder.tax_id',
    name: `SSN / EIN`,
    type: 'string',
    is_visible: false,
  },
  {
    key: 'shareholder.type',
    name: 'Type',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'shareholder.phone',
    name: 'Phone Number',
    type: 'string',
    is_visible: false,
  },
  ...addressColumns({ keyPrefix: 'shareholder' }),
]

const entity_investor_columns = (isAdmin: boolean): Column[] => [
  {
    key: 'id',
    name: 'Commitment ID',
    type: 'string',
    fixed: true,
    is_visible: false,
    sorted: true,
  },
  {
    key: 'shareholder.name',
    name: 'Investor',
    type: 'string',
    fixed: true,
    is_visible: true,
    sorted: true,
  },
  {
    key: 'shareholder.first_name',
    name: 'First Name',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.last_name',
    name: 'Last Name',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'shareholder.cid',
    name: 'Investor CID',
    type: 'string',
    align: 'left',
    is_visible: false,
    is_accessible: isAdmin,
  },
  {
    key: 'investor_sequence',
    name: 'Investor Sequence',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'tax_investor_name',
    name: 'Tax Investor Name',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'date',
    name: 'Date',
    type: 'date',
    is_visible: true,
  },
  {
    key: 'shareholder.email',
    name: 'Email',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'ownership',
    name: 'Ownership',
    type: 'percent',
    is_visible: false,
    aggregate: 'sum',
  },
  {
    key: 'committed',
    name: 'Committed',
    type: 'currency',
    aggregate: 'sum',
    is_visible: true,
  },
  {
    key: 'management_fee_percentage',
    name: 'Management Fee %',
    type: 'percent',
    is_visible: true,
  },
  {
    key: 'carried_interest_percentage',
    name: 'Carried Interest %',
    type: 'percent',
    is_visible: true,
  },
  {
    key: 'preferred_return_percentage',
    name: 'Preferred Return %',
    type: 'percent',
    is_visible: true,
  },
  {
    key: 'called',
    name: 'Called',
    type: 'currency',
    aggregate: 'sum',
    align: 'right',
    is_visible: true,
  },
  {
    key: 'management_fee_called',
    name: 'Management Fees',
    type: 'currency',
    aggregate: 'sum',
    align: 'right',
    is_visible: true,
  },
  {
    key: 'other_fee_called',
    name: 'Other Fees',
    type: 'currency',
    aggregate: 'sum',
    align: 'right',
    is_visible: true,
  },
  {
    key: 'commitment_remaining',
    name: 'Commitment Remaining',
    type: 'currency',
    aggregate: 'sum',
    align: 'right',
    is_visible: true,
  },
  {
    key: 'net_distributed',
    name: 'Distributions',
    type: 'currency',
    aggregate: 'sum',
    align: 'right',
    is_visible: true,
  },
  {
    key: 'cash_position',
    name: 'Cash Position',
    type: 'currency',
    aggregate: 'sum',
    is_visible: false,
  },
  ...shareholder_columns,
  {
    key: 'shareholder.investor_partner_name',
    name: 'Investor Partner',
    type: 'string',
    is_visible: false,
    is_accessible: isAdmin,
  },
  {
    key: 'shareholder.investor_partner_tax_id',
    name: 'Investor Partner Tax ID',
    type: 'string',
    is_visible: false,
    is_accessible: isAdmin,
  },
  {
    key: 'shareholder.birthdate',
    name: `Birthdate`,
    type: 'string',
    is_visible: false,
    is_accessible: isAdmin,
  },
  ...distribution_method_columns,
  {
    key: 'actions',
    name: '',
    type: 'actions',
    is_visible: true,
  },
]

const individual_entity_columns = (entityTabSelected: string, hidden?: HiddenMetrics): Column[] => [
  {
    key: 'name',
    name: 'Name',
    type: 'string',
    is_visible: true,
    fixed: true,
  },
  {
    key: 'insights.committed',
    name: 'Committed',
    type: 'currency',
    is_visible: true,
    aggregate: 'sum',
  },
  {
    key: 'structure.management_fee_rate',
    name: 'Management Fee %',
    type: 'percent',
    is_visible: true,
  },
  {
    key: 'structure.carried_interest_rate',
    name: 'Carried Interest %',
    type: 'percent',
    is_visible: true,
  },
  {
    key: 'structure.preferred_return_rate',
    name: 'Preferred Return %',
    type: 'percent',
    is_visible: true,
  },
  {
    key: 'insights.distributed_carried_interest',
    name: 'Carried Interest',
    type: 'currency',
    is_visible: false,
    aggregate: 'sum',
  },
  {
    key: 'insights.cash_position',
    name: 'Cash Position',
    type: 'currency',
    is_visible: false,
    aggregate: 'sum',
    is_accessible: !hidden?.cashPosition,
  },
  {
    key: 'legal_name',
    name: 'Legal Name',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'date',
    name: 'Date Established',
    type: 'date',
    is_visible: true,
  },
  {
    key: 'group.name',
    name: 'Group',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'group.subdomain',
    name: 'Subdomain',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'type',
    name: 'Legal Structure',
    type: 'string',
    is_visible: true,
  },
  {
    key: 'tax_id',
    name: 'EIN',
    type: 'string',
    is_visible: true,
  },
  {
    key: 'document_status',
    name: 'Document Status',
    type: 'string',
    is_visible: true,
  },
  {
    key: 'selected_subscriptions',
    csv_key: 'selected_services',
    name: 'Subscription',
    type: 'string',
    is_visible: true,
  },
  {
    key: 'manager',
    name: 'SPV Manager',
    type: 'string',
    align: 'left',
    is_visible: true,
    is_accessible: entityTabSelected === 'spvs',
  },
  {
    key: 'admins',
    name: 'Managers',
    type: 'string',
    is_visible: true,
  },
  {
    key: 'address.line1',
    name: 'Line 1',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'address.line2',
    name: 'Line 2',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'address.city',
    name: 'City',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'address.state',
    name: 'State',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'address.zip',
    name: 'Postal Code',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'address.country',
    name: 'Country',
    type: 'string',
    is_visible: false,
  },
]

const individual_other_entity_columns: Column[] = [
  {
    key: 'name',
    name: 'Name',
    type: 'string',
    is_visible: true,
    fixed: true,
  },
  {
    key: 'admins',
    name: 'Admins',
    type: 'string',
    is_visible: true,
  },
]

const individual_invoice_columns = (isAdmin: boolean, hidden_columns = []): Column[] => [
  {
    key: 'checkbox',
    name: '',
    type: 'string',
    is_visible: true,
    is_accessible: isAdmin,
    enable_thead_slot: true,
  },
  {
    key: 'name',
    name: 'Name',
    type: 'string',
    fixed: true,
    is_visible: !hidden_columns.includes('name'),
  },
  {
    key: 'investor.name',
    name: 'Investor',
    type: 'string',
    is_visible: !hidden_columns.includes('investor'),
  },
  {
    key: 'entity.name',
    name: 'Entity',
    type: 'string',
    is_visible: !hidden_columns.includes('entity.name'),
  },
  {
    key: 'date',
    name: 'Due Date',
    type: 'date',
    sorted: true,
    is_visible: !hidden_columns.includes('date'),
  },
  {
    key: 'marked_as_paid',
    name: 'Status',
    type: 'boolean',
    is_visible: !hidden_columns.includes('status'),
  },
  {
    key: 'total_amount',
    name: 'Amount Due',
    type: 'currency',
    is_visible: !hidden_columns.includes('total_amount'),
    aggregate: 'sum',
  },
  {
    key: 'paid_at',
    name: 'Paid Date',
    type: 'date',
    is_visible: !hidden_columns.includes('paid_at'),
  },
  {
    key: 'actions',
    name: '',
    type: 'actions',
    is_visible: isAdmin,
  },
]

const transactionColumns = (isAdmin?: boolean): Column[] => [
  {
    key: 'display_type',
    name: 'Transaction Type',
    type: 'string',
    fixed: true,
    is_visible: true,
    icon: true,
  },
  {
    key: 'commitment_id',
    name: 'Commitment ID',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'investor_cid',
    name: 'Investor CID',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'investor_sequence',
    name: 'Investor Sequence',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'tax_investor_name',
    name: 'Tax Investor Name',
    type: 'string',
    align: 'left',
    is_visible: false,
  },
  {
    key: 'company.name',
    name: 'Company',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'shareholder.name',
    name: 'Investor',
    type: 'string',
    is_visible: false,
  },
  {
    key: 'capital',
    name: 'Amount',
    type: 'currency',
    is_visible: true,
  },
  {
    key: 'date',
    name: 'Date',
    type: 'date',
    is_visible: true,
    sorted: true,
    sort_order: 'desc',
  },
  {
    key: 'status',
    name: 'Status',
    type: 'string',
    is_visible: true,
  },
  {
    key: 'actions',
    name: '',
    type: 'actions',
    is_visible: true,
  },
]

export {
  addressColumns,
  call_columns,
  entity_columns,
  entity_investor_columns,
  individual_entity_columns,
  individual_invoice_columns,
  individual_other_entity_columns,
  shareholder_columns,
  transactionColumns,
}
